<template>
	<div class="plugins-container">
		<div class="right-top-bar">
			<SidebarMicro ref="micro-sidebar" :items="sidebarItems" :base-path="basePath" @switched-item="switchedTab" />
		</div>
		<div class="content">
			<div class="navbar-container">
				<TopNavbar ref="top-navbar" show-micro-sidebar :sidebar-items="sidebarItems" :base-path="basePath" @switched-item="switchedTab">
					<template #content>
						<div class="row navbar-slot-content">
							<h3>{{ currentSidebarItem.name }}</h3>
							<div class="navbar-right-side">
							</div>
						</div>
					</template>
				</TopNavbar>
			</div>
			<div class="main-content">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import BusinessesSelect from "@/console-new/components/shared/BusinessesSelect.vue";
import SidebarMicro from "@/console-new/components/shared/SidebarMicro.vue";
import TopNavbar from "@/console-new/components/shared/TopNavbar.vue";

import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore, useFunnelStore, useRoomsStore, useMarketplaceStore} from "@/console-new/stores";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let roomsStore = useRoomsStore();
		let marketplaceStore = useMarketplaceStore();
		let funnelStore = useFunnelStore();
		let notificationStore = useNotificationStore();
		return {getString: languageStore.getString, notificationStore, funnelStore, marketplaceStore, roomsStore, userStore}
	},
	name: "PluginsContainer",
	components: {AppButtonIcon, BusinessesSelect, SidebarMicro, TopNavbar},
	data() {
		return {
			basePath: "/help",
			currentTab: 0,
		}
	},
	computed: {
		sidebarItems() {
			return [{
				name: this.getString('chat_bot'),
				icon: "iconChatBot",
				path: "/chat",
				/*class: "main-button",*/
				shown: true
			},/* TODO notifications section
			{
				name: this.getString('notifications'),
				icon: "iconBellOutline",
				path: "/notifications",
				/!*class: "main-button",*!/
				shown: true
			}*/]
		},
		currentSidebarItem() {
			return this.sidebarItems[this.currentTab];
		},
	},
	methods: {
		switchedTab(index) {
			this.currentTab = index;
		},
	},
}
</script>

<style lang="scss" scoped>
.plugins-container {
	display: flex;
	flex-direction: row;
	height: 100%;

	.right-top-bar {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		width: 250px;
		height: 100%;
		box-shadow: 0 1px 3px var(--color-alpha-3);

		.sidebar-micro {
			@include hideScrollbar;
			overflow-y: auto;
			border-top: 1px solid var(--color-alpha-3);
		}


	}

	.content {
		width: calc(100% - 250px);
	}
	.main-content {
		width: 100%;
		height: calc(100% - 60px);
	}

	.navbar-container {
		z-index: 11;
		height: 60px;
		width: 100%;

		.navbar-slot-content {
			align-items: center;
			justify-content: space-between;
			height: 100%;
			padding: 0 10px;

			@media (max-width: 920px) {
				padding: 0 10px 0 2px;
			}
		}

	}

	.multi-select-btn {
		display: flex;
		margin-left: auto;
		margin-right: 20px;
	}

	@media (max-width: 1200px) {

		.right-top-bar {
			width: 220px;
		}

		.content {
			width: calc(100% - 220px);
		}
	}

	@media (max-width: 920px) {
		.navbar-container {
			width: 100%;
		}
		.right-top-bar {
			display: none;
		}
		.content {
			width: 100%;
		}
	}

	@media (max-width: 768px) {
		.main-content {
			width: 100%;
		}
	}

}
</style>